export default __webpack_public_path__ + "static/media/beautyatluxx.4b733042.png";